
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelSphere as ObiBuoyBarrelSphereElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-sphere.js';
 
 
 

 
 export const ObiBuoyBarrelSphere = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-sphere',
   elementClass: ObiBuoyBarrelSphereElement,
   events: {
     
   }
  });
 
 